"use client";

import { ArrowLeftIcon } from "@heroicons/react/24/outline";

import { StepRenderer } from "@/app/(application)/(normal)/account/components/cancelSubscriptionLink/cancelSubscriptionModal/steps/StepRenderer";
import { Modal } from "@/components/Modal";
import { NormalText } from "@/components/text/NormalText";
import { UserNoDates } from "@/types/types";
import { useSubscriptionCancellation } from "@/utils/hooks/useSubscriptionCancellation";

export function CancelSubscriptionModal({
  open,
  closeModal,
  user,
  numberOfModels,
  numberOfMixedModels,
}: {
  open: boolean;
  closeModal: () => void;
  user: UserNoDates;
  numberOfModels: number;
  numberOfMixedModels: number;
  subscriptionDurationInMonths: number;
}) {
  const {
    currentStep,
    selectedReason,
    stepHistory,
    offeredDiscount,
    wasCancelledImmediately,
    handleChoice,
    handleBack,
    handleClose,
    handleCancellationCompleted,
    shuffleArray,
  } = useSubscriptionCancellation({
    closeModal: closeModal,
    isOpen: open,
  });

  return (
    <Modal
      open={open}
      closeModal={handleClose}
      title="Cancel subscription"
      widthMode="normal"
    >
      <div className="space-y-6">
        {stepHistory.length > 1 && currentStep.id !== "success_cancellation" ?
          <button
            onClick={handleBack}
            className="group flex items-center gap-x-2"
          >
            <ArrowLeftIcon className="h-4 text-gray-900 transition-colors group-hover:text-gray-600" />
            <NormalText
              elementType="span"
              className="transition-colors group-hover:text-gray-600"
            >
              Back
            </NormalText>
          </button>
        : null}

        <StepRenderer
          currentStep={currentStep}
          user={user}
          numberOfModels={numberOfModels}
          numberOfMixedModels={numberOfMixedModels}
          selectedReason={selectedReason}
          offeredDiscount={offeredDiscount}
          wasCancelledImmediately={wasCancelledImmediately}
          handleChoice={handleChoice}
          handleClose={handleClose}
          onCancellationCompleted={handleCancellationCompleted}
          shuffleArray={shuffleArray}
        />
      </div>
    </Modal>
  );
}
